<i18n>
{
  "en": {
    "otp": {
      "sms": {
        "lead": "Could not deliver verification code by sms."
      },
      "ivr": {
        "lead": "Could not deliver verification code by phone call."
      }
    },
    "solution": "Please go back to the service you tried to use.",
    "solution-fallback": "SMS sending failed. You can receive the verification code from a phone call.",
    "ivr-fallback": "Get verification code by phone call."
  },
  "no": {
    "otp": {
      "sms": {
        "lead": "Kunne ikke levere bekreftelseskode med sms."
      },
      "ivr": {
        "lead": "Kunne ikke levere bekreftelseskode ved oppringing."
      }
    },
    "solution": "Gå tilbake til tjenesten du kom fra for å prøve på nytt eller andre alternativer.",
    "solution-fallback": "SMS utsending feilet. Du kan bli oppringt for å få bekreftelseskoden.",
    "ivr-fallback": "Bli oppringt for bekreftelseskoden."
  }
}
</i18n>

<template>
  <FormWrapper>
    <div class="page-md">
      <TnNotificationInline horizontal status="critical" full-width class="margin-vertical-2xl">
        {{ t(`otp.${ivrOrSms}.lead`) }}
      </TnNotificationInline>

      <TnHeading type="h1" size="s" align="center" class="margin-vertical-2xl">
        {{ fallbackAllowed ? t('solution-fallback') : t('solution') }}
      </TnHeading>

      <TnButton
        v-if="fallbackAllowed"
        primary
        block
        class="margin-bottom-l"
        @click="triggerFallback"
      >
        <img :src="telenorLogoWhite" alt="" aria-hidden="true" class="btn-logo" />
        {{ t('ivr-fallback') }}
      </TnButton>

      <div class="margin-top-l text-center">
        <TnLink :href="startUrl" :text="startUrl" />
      </div>
    </div>
  </FormWrapper>
</template>

<script setup lang="ts">
import { computed } from 'vue';
import { useRoute } from 'vue-router';
import { useI18n } from 'vue-i18n';
import {
  TnButton,
  TnHeading,
  TnLink,
  TnNotificationInline,
} from '@telenornorgeinternal/telegrafen-vue3-core';

import FormWrapper from '@/components/FormWrapper.vue';
import telenorLogoWhite from '@/assets/telenor-logo-flat-white.svg';
import { fallbackLogin } from '@/views/kookaburra/api';

const { t } = useI18n();
const route = useRoute();

const isTest = computed(() => location.hostname.includes('test'));

const startUrl = computed(() =>
  isTest.value ? 'https://mbn-at.telenor.no/start' : 'https://mbn.telenor.no/start',
);

const ivrOrSms = computed(() => (route.query.ivr === 'true' ? 'ivr' : 'sms'));

const fallbackAllowed = computed(
  () => route.query.ivr !== 'true' && route.query.attemptFallback === 'true',
);

function triggerFallback() {
  fallbackLogin().catch((err) => console.error(err));
}
</script>
